import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Export } from '../../../../../../pages/project/settings/Export';
import { Centered } from '../../../../../../components/atoms/layouts/Centered';
import { Loader } from '../../../../../../components/molecules/loader/Loader';
import { getProjectQuizesQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/export')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(getProjectQuizesQueryOptions(context.apiClient, params.project_id)),
  component: ExportRoute,
  pendingComponent: () => (
    <Centered>
      <Loader label="Loading export settings..." />
    </Centered>
  ),
});

function ExportRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Export projectId={project_id} portalApiClient={apiClient} />;
}
